module.exports = __webpack_public_path__ + "static/hero-popsicle-49a9234b2f6da6ef4704d6d32963b909.jpg";